<template>
  <div>
    <el-card>
      <el-row
        v-for="(item, index) in list"
        :key="index"
        style="margin-top: 10px"
      >
        <el-row>{{ item.questionName }}</el-row>
        <el-row
          v-if="item.remark"
          style="
            color: #f00;
            margin-left: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
          "
          >{{ item.remark }}</el-row
        >
        <el-row v-if="item.questionType == 'radio'">
          <el-radio-group v-model="item.answer">
            <el-radio
              :label="options.id"
              v-for="(options, idx) in item.sanboQuestionOptionList"
              :key="idx"
              style="display: block; margin-left: 10px; margin-top: 10px"
              >{{ options.optionName }}</el-radio
            >
          </el-radio-group>
        </el-row>
        <el-row
          v-else-if="item.questionType == 'text'"
          style="margin-top: 10px"
        >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="item.answer"
          >
          </el-input>
        </el-row>
        <el-row
          v-else-if="item.questionType == 'date'"
          style="margin-top: 10px"
        >
          <el-input placeholder="请输入内容" v-model="item.answer"> </el-input>
        </el-row>
        <el-row
          v-else-if="item.questionType == 'check'"
          style="margin-top: 10px"
        >
          <el-checkbox-group v-model="checkList">
            <el-checkbox
              style="display: block; margin-left: 10px; margin-top: 10px"
              :label="option.optionName"
              v-for="(option, idx) in item.sanboQuestionOptionList"
              :key="idx"
            ></el-checkbox>
          </el-checkbox-group>
        </el-row>
        <el-row v-else-if="item.questionType == 'pic'" style="margin-top: 10px">
          <el-image
            v-for="(Imgsrc,idx) in item.answer"
            style="width: 100px; height: 100px;margin-left:10px;"
            :src="Imgsrc"
            :preview-src-list="item.answer"
            :key="idx"
          ></el-image>
        </el-row>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      list: [],
      checkList: [],
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.questionnaire.question.option.list",
          memberId: _this.$route.query.memberId,
          questionnaireId: _this.$route.query.id,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
              var List=obj.sanboQuestionnaire.sanboQuestionnaireVo.questionList;
              for(let i in List ){
                  if(List[i].questionType=='pic'){
                        List[i].answer=List[i].answer.split(',');
                  }
              }
            _this.list =List;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>
<style scoped>
</style>